import React from 'react';
import './medical-services.scss';

export function MedicalServices(props) {
  return (
    <div className="card add_bottom_45">
      <div className="card-body">
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <h3>Перечень медицинских услуг</h3>
        </div>
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div className="list-group">
            {props.items.map(product => (
              <div className="list-group-item" key={product.id}>
                <a href={`/services/medical-services/${product.id}`}>
                  {product.name}
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default MedicalServices;
